(() => {
  const initGallery = (root) => {
    if (root.dataset.gczSharedReady === 'true') return;
    root.dataset.gczSharedReady = 'true';

    const items = Array.from(root.querySelectorAll('[data-gcz-shared-media]'));
    const thumbs = Array.from(root.querySelectorAll('[data-gcz-shared-thumb]'));
    const current = root.querySelector('[data-gcz-shared-current]');
    const previous = root.querySelector('[data-gcz-shared-prev]');
    const next = root.querySelector('[data-gcz-shared-next]');
    if (!items.length || items.length !== thumbs.length) return;

    let activeIndex = 0;
    const activate = (index, focusThumb = false) => {
      activeIndex = (index + items.length) % items.length;
      items.forEach((item, itemIndex) => { item.hidden = itemIndex !== activeIndex; });
      thumbs.forEach((thumb, thumbIndex) => {
        const selected = thumbIndex === activeIndex;
        thumb.setAttribute('aria-selected', String(selected));
        thumb.tabIndex = selected ? 0 : -1;
      });
      if (current) current.textContent = String(activeIndex + 1);
      if (focusThumb) thumbs[activeIndex].focus();
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => activate(index));
      thumb.addEventListener('keydown', (event) => {
        let target = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = index + 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = index - 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = thumbs.length - 1;
        if (target === null) return;
        event.preventDefault();
        activate(target, true);
      });
    });
    previous?.addEventListener('click', () => activate(activeIndex - 1));
    next?.addEventListener('click', () => activate(activeIndex + 1));
    activate(0);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-gcz-shared-gallery]').forEach(initGallery);
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
